import { Action } from '@ngrx/store';

export enum TablesActionType {
  GET_TABLES = '[Table] Get',
}
export class GetTablesAction implements Action {
  readonly type = TablesActionType.GET_TABLES;
  //add an optional payload
  constructor(public payload: any) {}
}

export type CrudTableAction = GetTablesAction ;
